import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { allFidelity, AllShop, ArticoloPromoN, ArticoloPromoScorta, ArticoloStoricoPrezzo, ArticoloThermoVirtuale, BlackListNewsletter, BuonoValore, CodeValue, CouponValore, EditNotificaPush, fidelity, GetReport, ImgBuoniUtilizo, NotificaPush, OffertaB2c, OffertaCedi, OffertaDettaglioB2c, Promo, RecuperoDatiPromo, ReportCoupon, Response, selectArticleFlagPromoScorta, Shop, ShowAllBuoniValoreFidelity, TipoCodice, UpdateShopPushNotificationRequest } from '@app/_models';
import { ArticoloContingentato, ArticoloContingementatoCreate, ArticoloContingementatoUpdate, ArticoloContingementatoUploadRequest, ArticoloContingementatoUploadResponse } from '@app/_models/contingentati-models';
import { Volantini, VolantinoPdf } from '@app/_models/volantini.model';
import { environment } from '@environments/environment';
import { BehaviorSubject, Observable, of, ReplaySubject } from 'rxjs';
import { catchError, first, map } from 'rxjs/operators';

import { BaseService } from './base.service';
import { HandleError, HttpErrorHandlerService } from './http-error-handler.service';
import { LoggerService } from './logger.service';

@Injectable({
  providedIn: 'root'
})
export class B2cService {

  private seriesEndpoint = "B2C/Promo/Series";
  private shopListEndpoint = "B2C/Shop/List";
  private articoloThermoVirtuale = "B2C/Thermovirtuale/Articolo"
  private updateFlagThermo = "B2C/Thermovirtuale/UpdateFlagOrdinePrezzoSfuso"
  private promoListEndpoint = "B2C/Promo/List";
  private promoDetailEndpoint = "B2C/Promo/Detail";
  private promoScortaUploadEndpoint = "B2C/Promo/Upload";
  private promoCediUploadEndpoint ="B2C/Promo/Cedi/Upload"
  private promoRecuperoFileEndpoint = "B2C/Promo/RecuperoDati"
  private promoScortaDeleteEndpoint = "B2C/Promo/Delete";
  private promoScortaAddOrUpdateArticle ="B2C/Promo/InsertOrUpdateArticle"
  private promoAddOrUpdateArticle ="B2C/Promo/InsertOrUpdateArticle"
  private promoScortaFlagDelete ="B2C/Promo/FlagDeleteAllArticle"
  private promoScortaWarningNumber = "B2C/Promo/GetWarningPromoScortaQuantita"
  private promoScortaWarningPrezzo = "B2C/Promo/GetWarningPromoScortaPrezzo"
  private promoCheckArticolo = "B2C/Promo/ArticleCheckPromo"

  private buonoValoreListEndpoint = "B2C/BuoniValore/List";
  private buonoValoreDetailEndpoint = "B2C/BuoniValore/Detail";
  private buonoValoreFidelityEndpoint = "B2C/BuoniValore/Fidelity";
  private buonoValoreUploadEndpoint = "B2C/BuoniValore/Upload";
  private buoniValoreDeleteEndpoint = "B2C/BuoniValore/Delete";

  private buonoValoreFidelityAdd = "B2C/BuoniValore/AddFidelities";
  private buonoValoreFidelityAddBulk = "B2C/BuoniValore/AddFidelitiesBulk";
  private buonoValoreFidelityAddAllConnected = "B2C/BuoniValore/AddAllFidelitiesConnected";
  private buonoValoreFidelityAddByShops = "B2C/BuoniValore/AddFidelitiesByShops";
  private buonoValoreFidelityDelete = "B2C/BuoniValore/RemoveFidelities";
  private buonoValoreFidelityUpdate = "B2C/BuoniValore/UpdateFidelity";
  private buonoValoreFidelityRemoveAll = "B2C/BuoniValore/RemoveAllFidelities";
  private buonoValoreFidelityHideAll = "B2C/BuoniValore/HideAllFidelityFromApp";
  private buonoValoreFidelityShowAll = "B2C/BuoniValore/ShowAllFidelityOnApp";
  private buonoValoreActiveAll = "B2C/BuoniValore/ActiveAllFidelityFromApp";
  private buonoValoreDisableAll = "B2C/BuoniValore/DisableAllFidelityFromApp";
  private buonoValoreUploadPng = "B2C/BuoniValore/UploadImage";
  private reportCouponEndPoint = "B2C/Coupon/Report"

  private volantiniListEndPoint = "B2C/Volantini/GetAll";
  private volantiniUpdateOrInsert = "B2C/Volantini/InsertOrUpdate";
  private volantiniUploadPDF = "B2C/Volantini/UploadPdf";
  private deletevolantino = "B2C/Volantini/Remove?id=";

  private codeValueData = "B2C/GetCodeValueData";

  //notifiche
  private notificheListEndPoint ="B2C/PushNotification/Get"
  private getFidelityWithDevice = "B2C/PushNotification/GetFidelityWithDevices"
  private insertNotification = "B2C/PushNotification/SchedulerPushNotification"
  private insertNotificationAsync = "B2C/PushNotification/SchedulerPushNotificationAsync"
  private notificationTaskStatus = "B2C/PushNotification/TaskStatus/"
  private fidelityCountForNotification = "B2C/PushNotification/GetFidelityCount"
  private updateFidelityNotification ="B2C/PushNotification/UpdatefidelitySchedulerPushNotification"
  private updateNotification ="B2C/PushNotification/UpdateSchedulerPushNotification"
  private deleteNotification = "B2C/PushNotification/RemoveNotification?id=";

  private handleError: HandleError;

  //articoliVariazione
  private getArticoliVariazioneEndPoint = "B2C/Articoli/GetPrezziVariati"

  //fidelity
  private getAllFidelityEndPoint = "B2C/fidelity/GetAll"
  private getShopSearch = "B2C/Shop/ListForSearch"
  private getDigitalFidelity ="BackOfficeMcdsApi/GetFidelityConnectedToAppWithFlag_1"
  private getDigitalFidelityNotInBlackList = "BackOfficeMcdsApi/GetFidelityConnectedToAppWithFlag_1NotInBlackList"
  private getAllDigitalFidelity ="BackOfficeMcdsApi/GetAllFidelityConnectedToApp"
  private getAllDigitalFidelityForReport = "BackOfficeMcdsApi/GetAllFidelityConnectedToAppForReport"
  private getAllDigitalFidelityForShop ="BackOfficeMcdsApi/GetAllFidelityConnectedToAppForShop"
  private getFidelityNotificationForShopEndPoint = "BackOfficeMcdsApi/GetFidelityConnectedToAppWithFlag_1ForShop"
  private getAllFidelityWithNotificationPush = "BackOfficeMcdsApi/GetFidelityConnectedToAppWithNotificationPushDevice"
  private getBuonoValoreForFidelityEndPoint ="B2C/Fidelity/ShowAllBuoniValore"

  //BlackList
  private insertFidelityBlackList ="B2C/BlackList/InsertFidelity"
  private getFidelityBlackList ="B2C/BlackList/GetFidelitiesBlackList"

  // Articoli Contingentati B2C
  private getArticoliContingentatiEndpoint = "B2C/ArticoliContingentati/List"
  private uploadArticoliContingentatiEndpoint = "B2C/ArticoliContingentati/Upload"
  private updateArticoloContingementatoEndpoint = "B2C/ArticoliContingentati/Update"
  private getNegoziForContingentatiEndpoint = "B2C/Shop/ListForContingentati"

  // Promo
  private selectedPromoSerie: ReplaySubject<string>;
  public selectedPromoSerie$: Observable<string>;

  private promosSubject: ReplaySubject<OffertaB2c[]>;
  public promos: Observable<OffertaB2c[]>;

  public selectedPromo?: OffertaB2c;

  //banner
  private changeBanner:ReplaySubject<string>;;
  public changeBanner$:Observable<string>;

  // Buoni Coupons
  private selectedBuonoType: ReplaySubject<string>;
  public selectedBuonoType$: Observable<string>;

  private buonoList: ReplaySubject<BuonoValore[]>;
  public buonoList$: Observable<BuonoValore[]>;

  public selectedBuono?: BuonoValore;

  private couponList: BehaviorSubject<CouponValore[]>;
  public couponList$: Observable<CouponValore[]>;

  

  // tenere lista dei buoni K ed E per una tendina nell'aggiunta dee buoni

  constructor(
    private router: Router,
    private baseService: BaseService,
    private http: HttpClient,
    httpErrorHandler: HttpErrorHandlerService,
    private logger: LoggerService
  ) {
    this.handleError = httpErrorHandler.createHandleError('B2cService');

    // Promozioni
    this.promosSubject = new ReplaySubject<OffertaB2c[]>(1);
    this.promosSubject.next([]);
    this.promos = this.promosSubject.asObservable();

    // add Promo Dettaglio as subject/observable

    //Banner
      this.changeBanner = new ReplaySubject<string>(1);
      this.changeBanner$ = this.changeBanner.asObservable();
    // Tipo promozioni
    this.selectedPromoSerie = new ReplaySubject<string>(1);
    this.selectedPromoSerie.next("M");
    this.selectedPromoSerie$ = this.selectedPromoSerie.asObservable();

    // Buoni Coupon
    this.selectedBuonoType = new ReplaySubject<string>(1);
    this.selectedBuonoType.next("std");
    this.selectedBuonoType$ = this.selectedBuonoType.asObservable();

    this.buonoList = new ReplaySubject<BuonoValore[]>(1);
    this.buonoList.next([]);
    this.buonoList$ = this.buonoList.asObservable();

    // Initialize couponList BehaviorSubject (no subscription needed!)
    this.couponList = new BehaviorSubject<CouponValore[]>([]);
    this.couponList$ = this.couponList.asObservable();
  }

  // Getter for synchronous access to coupons (no subscription needed!)
  private get coupons(): CouponValore[] {
    return this.couponList.value;
  }
  //BlackList
  
  InsertFidelityBlackList(fidelity:BlackListNewsletter[]): Observable<any> {
    if (fidelity) {
      return this.baseService.postRequestNEW(fidelity, this.insertFidelityBlackList);
    }
    return of(null);
  }
  getAllPaginateFidelityBlackList(page: number, perPage: number,search:string,searchName:string,searchShop:string): Observable<{ data: allFidelity[], total: number }> {
    if (page != 0) {
     return this.baseService.getPaginatedNEW<allFidelity>(this.getFidelityBlackList, page, perPage, { NumeroFidelity: search,SearchNameSurname: searchName,SearchShop:searchShop})
       .pipe(
         map(({ data, total }) => {
           return {
             data,
             total
           }
         })
       )
   }
   return of({ data: [], total: 0 }); 
 }
 //coupon report
 ReportCoupon(codForReport: GetReport): Observable<any> {
  if (codForReport) {
    return this.baseService.postRequestNEW(codForReport, this.reportCouponEndPoint);
  }
  return of(null);
}

  //banner
  updateBanner(update:any){
    this.changeBanner.next(update)
  }
  //articoli prezzi variati
  getPrezziVariati(page: number, perPage: number,searchShop:string, cod_articolo:string,exportExcel:boolean): Observable<{ data: ArticoloStoricoPrezzo[], total: number }> {
    if (page != 0) {
     return this.baseService.getPaginatedNEW<ArticoloStoricoPrezzo>(this.getArticoliVariazioneEndPoint, page, perPage, { cod_negozio:searchShop,cod_articolo:cod_articolo, ExportExcel:exportExcel}, )
       .pipe(
         map(({ data, total }) => {
           return {
             data,
             total
           }
         })
       )
   }
   return of({ data: [], total: 0 }); 
 }


  //fidelity
  getAllPaginateFidelity(page: number, perPage: number,search:string,searchName:string,searchShop:string,blacklist:boolean,fidelityNotify:boolean, digitalFidelity:boolean, exportExcel:boolean): Observable<{ data: allFidelity[], total: number }> {
     if (page != 0) {
      return this.baseService.getPaginatedNEW<allFidelity>(this.getAllFidelityEndPoint, page, perPage, { NumeroFidelity: search,SearchNameSurname: searchName,SearchShop:searchShop, Blacklist:blacklist, FidelityNotify:fidelityNotify, FidelityConnectToApp:digitalFidelity, ExportExcel:exportExcel}, )
        .pipe(
          map(({ data, total }) => {
            return {
              data,
              total
            }
          })
        )
    }
    return of({ data: [], total: 0 }); 
  }

  getAllCouponForFidelity(request: ShowAllBuoniValoreFidelity): Observable<ReportCoupon[]> {
    if (request) {
      return this.baseService.postRequestNEW(request, this.getBuonoValoreForFidelityEndPoint);
    }
    return of()
  }

  getShopForSearch(): Observable<Shop[]> {
    return this.http.get<Response<Shop[]>>(environment.apiURL + environment.apiVersion + this.getShopSearch)
      .pipe(
        map(response => response.content),
        catchError(this.handleError(this.getShopSearch))
      )
  }

  getShopForArticoliVariazioni(): Observable<AllShop[]> {
    return this.http.get<Response<AllShop[]>>(environment.apiURL + environment.apiVersion + this.getShopSearch)
      .pipe(
        map(response => response.content),
        catchError(this.handleError(this.getShopSearch))
      )
  }
    public getFidelityConnectToApp(): Observable<any> {
      return this.http.get(environment.apiURL + environment.apiVersion + this.getDigitalFidelity, { observe: 'response' });
    }
    public getFidelityConnectToAppNotInBlackList(): Observable<any> {
      return this.http.get(environment.apiURL + environment.apiVersion + this.getDigitalFidelityNotInBlackList, { observe: 'response' });
    }
    public getAllFidelityConnectToApp(): Observable<any> {
      return this.http.get(environment.apiURL + environment.apiVersion + this.getAllDigitalFidelity, { observe: 'response' });
    }

    public getAllFidelityConnectToAppForReport(): Observable<any> {
      return this.http.get(environment.apiURL + environment.apiVersion + this.getAllDigitalFidelityForReport, { observe: 'response' });
    }
    getAllFidelityConnectToAppForShop(codShop:string[]): Observable<any> {
      if (codShop) {
        const params = {
          codNegozio: codShop
        }
        return this.http.post(environment.apiURL + environment.apiVersion + this.getAllDigitalFidelityForShop, params)
      }
      return of()
    }
    public getFidelityConnectToAppWithNotificationOnApp(): Observable<any> {
      return this.http.get(environment.apiURL + environment.apiVersion + this.getAllFidelityWithNotificationPush, { observe: 'response' });
    }

    getNotificationFidelityForShop(codShop:string[]): Observable<any> {
      if (codShop) {
        const params = {
          codNegozio: codShop
        }
        return this.http.post(environment.apiURL + environment.apiVersion + this.getFidelityNotificationForShopEndPoint, params)
      }
      return of()
    }

  // Promozioni (Promoscorta)
  
  addOrUpdateArticlePomoScorta(articolo: ArticoloPromoScorta): Observable<any> {
    if (articolo) {
      return this.baseService.postRequestNEW(articolo, this.promoScortaAddOrUpdateArticle);
    }
    return of(null);
  }
  addOrUpdateArticoloPromo(articolo: ArticoloPromoN):Observable<any> {
    if (articolo) {
      return this.baseService.postRequestNEW(articolo, this.promoAddOrUpdateArticle);
    }
    return of(null);
  }
  setFlagDeletePromoScorta(articolo: selectArticleFlagPromoScorta): Observable<any> {
    if (articolo) {
      return this.baseService.postRequestNEW(articolo, this.promoScortaFlagDelete);
    }
    return of(null);
  }
  getWarningNumArticoli(promo: Promo): Observable<any> {
    if (promo) {
      return this.baseService.postRequestNEW(promo, this.promoScortaWarningNumber);
    }
    return of(null);
  }
  getWarningNumArticoliPrezzo(promo: Promo): Observable<any> {
    if (promo) {
      return this.baseService.postRequestNEW(promo, this.promoScortaWarningPrezzo);
    }
    return of(null);
  }



  promoTestateRefresh(serie: string = "", onlyActive: boolean = true) {
    // Usa nuovo endpoint REST-friendly con query parameters: /Promo/List?serie=K&onlyActive=true
    // getOnce non supporta query params, costruiamo l'URL manualmente
    const url = `${this.promoListEndpoint}?serie=${serie}&onlyActive=${onlyActive}`;
    return this.baseService.getOnce<OffertaB2c[]>(url, (data: OffertaB2c[]) => {
      this.promosSubject.next(data);
    });
  }

  loadPromozioni(serie: string = "", onlyActive: boolean = true): Observable<OffertaB2c[]> {
    // Usa nuovo endpoint REST-friendly con query parameters: /Promo/List?serie=K&onlyActive=true
    const queryParams = { serie, onlyActive: onlyActive.toString() };
    return this.baseService.getOnceNEW<OffertaB2c[]>(this.promoListEndpoint, queryParams);
  }

  public selectPromoSerie(serie: string) {
    this.selectedPromoSerie.next(serie);
    // Nella tab Promo, carica TUTTE le promozioni (anche scadute) per permettere la gestione completa
    this.promoTestateRefresh(serie, false)  // onlyActive=false
      .pipe(first())
      .subscribe({
        error: err => this.logger.error(`Failed to refresh promos for serie ${serie}`, err)
      });
  }

  public selectPromo(promo?: OffertaB2c) {
    this.selectedPromo = promo;
    // Always navigate to detail page, regardless of promo value (null/undefined for new promo)
    this.router.navigate(['/b2c/promo/dettaglio']);
  }

  promoDettaglio(): Observable<OffertaB2c[]> {
    if (this.selectedPromo) {
      return this.http.post<Response<OffertaB2c[]>>(environment.apiURL + environment.apiVersion + this.promoDetailEndpoint, this.selectedPromo)
        .pipe(
          map(response => response.content),
          catchError(this.handleError(this.promoDetailEndpoint))
        )
    }
    else {
      const none: OffertaB2c[] = [];
      return of(none);
    }
  }

  promoUpload(promo: OffertaB2c) {
    return this.baseService.postRequest<OffertaB2c[]>(promo, this.promoScortaUploadEndpoint, (_data: any) => {
      this.router.navigate(['/b2c/promo']);
    });
  }

  promoCediUplaod(promo:OffertaCedi): Observable<number>{
    return this.baseService.postRequestNEW<number>(promo,this.promoCediUploadEndpoint);
  }

  recuperoFilePromo(dati:RecuperoDatiPromo): Observable<any>{
    return this.baseService.postRequestNEW<any>(dati,this.promoRecuperoFileEndpoint);
  }

  downloadFileTxt(dati:RecuperoDatiPromo): Observable<any> {
    // Create url using alternative API endpoint
    const url = `${environment.apiURLAlternative}${environment.apiVersion}${this.promoRecuperoFileEndpoint}`;
    return this.http.post(url, dati, {
      responseType: "blob",
    });
  } 

  promoDelete(promos: OffertaB2c[]) {
    return this.baseService.postRequest<OffertaB2c[]>(promos, this.promoScortaDeleteEndpoint, (data: OffertaB2c[]) => {
      this.promosSubject.next(data);
    });
  }

  getArticoliCheckPromo(codiceArticolo:string){
    return this.baseService.getOnceNEW(this.promoCheckArticolo+ "?codArticle="+codiceArticolo.toString());
  }

  // Shops

  shopList(): Observable<Shop[]> {
    return this.http.get<Response<Shop[]>>(environment.apiURL + environment.apiVersion + this.shopListEndpoint)
      .pipe(
        map(response => response.content),
        catchError(this.handleError(this.shopListEndpoint))
      )
  }

  //thermo virtuale
  getArticoloThermoVirtuale(codiceArticolo:string){
    return this.baseService.getOnceNEW(this.articoloThermoVirtuale + "?codArticle="+codiceArticolo.toString());
  }

  updateFlagThermoVirtuale(shop:String[]):Observable<any>{
    if (shop) {
      return this.baseService.postRequestNEW(shop, this.updateFlagThermo);
    }
    return of(null);
  }

  //Volantini

  getVolantiniList(): Observable<Volantini[]> {
    return this.http.get<Response<Volantini[]>>(environment.apiURL + environment.apiVersion + this.volantiniListEndPoint)
      .pipe(
        map(response => response.content),
        catchError(this.handleError(this.volantiniListEndPoint))
      )
  }

  VolantiniUpdateOrInsert(volantini: Volantini): Observable<any> {
    if (volantini) {
      return this.baseService.postRequestNEW(volantini, this.volantiniUpdateOrInsert);
    }
    return of(null);
  }

  volantiniUploadPdf(volantinoPdf: VolantinoPdf): Observable<any> {
    if (volantinoPdf) {
      return this.baseService.postRequestNEW(volantinoPdf, this.volantiniUploadPDF);
    }
    return of(null);
  }
  volantiniDelete(elemnt: any): Observable<any> {

    if (elemnt) {
      const params = {
        id: elemnt.id as string,

      }
      /* this.deletevolantino = this.deletevolantino + elemnt.id; */
      return this.baseService.getOnceNEW(this.deletevolantino + elemnt.id);
    }
    return of(null)
  }

  //Notifiche
  listNotification(): Observable<any> {
    return this.baseService.getOnceNEW(this.notificheListEndPoint);
    }

  listFidelityWithDevice(): Observable<any> {
      return this.baseService.getOnceNEW(this.getFidelityWithDevice);
      }

  insertPushNotification(notify: NotificaPush): Observable<any> {
      if (notify) {
        return this.baseService.postRequestNEW(notify, this.insertNotification);
      }
      return of(null);
     }

  insertPushNotificationAsync(notify: NotificaPush): Observable<any> {
      if (notify) {
        return this.baseService.postRequestNEW(notify, this.insertNotificationAsync);
      }
      return of(null);
     }

  getNotificationTaskStatus(idTask: number): Observable<any> {
      return this.baseService.getOnceNEW(this.notificationTaskStatus + idTask);
     }

  getFidelityCountForNotification(payload: any): Observable<any> {
      return this.baseService.postRequestNEW(payload, this.fidelityCountForNotification);
     }

     updateFidelityPushNotification(notify: UpdateShopPushNotificationRequest): Observable<any> {
      if (notify) {
        return this.baseService.postRequestNEW(notify, this.updateFidelityNotification);
      }
      return of(null);
     }
     updatePushNotification(notification: EditNotificaPush): Observable<any> {
      if (notification) {
        return this.baseService.postRequestNEW(notification, this.updateNotification);
      }
      return of(null);
     }
     notificationDelete(elemnt: any): Observable<any> {
      if (elemnt) {
        const params = {
          id: elemnt.id as string,
        }
        /* this.deletevolantino = this.deletevolantino + elemnt.id; */
        return this.baseService.getOnceNEW(this.deleteNotification + elemnt.id);
      }
      return of(null)
    }

  // Buono Valore

  buonoValoreDelete(coupons: BuonoValore[]) {
    return this.baseService.postRequest<BuonoValore[]>(coupons, this.buoniValoreDeleteEndpoint, (data: BuonoValore[]) => {
      this.buonoList.next(data);
    });
  }

  buonoUploadPng(pngBuono: ImgBuoniUtilizo): Observable<any> {
    if (pngBuono) {
      return this.baseService.postRequestNEW(pngBuono, this.buonoValoreUploadPng);
    }
    return of(null);
  }

  selectBuonoType(page: number, perPage: number,type: string) {
    this.selectedBuonoType.next(type);
    this.buonoValoreListRefresh(page,perPage,type) // always refresh otherwise new additions may be lost
      .pipe(first())
      .subscribe({
        next: data => this.buonoList.next(data.data),
        error: err => this.logger.error(`Failed to refresh buoni valore for type ${type}`, err)
      });
  }

  selectBuono(buono?: BuonoValore) { // check if it works with null
    this.selectedBuono = buono;
    if (this.selectedBuono !== undefined) {
      this.router.navigate(['/b2c/buoni/dettaglio']);
    }
  }

  buonoValoreListRefresh(page: number, perPage: number,serie: string): Observable<{ data: BuonoValore[], total: number }> {
    this.selectedBuonoType.next(serie);
    return this.baseService.getPaginatedNEW<BuonoValore>(this.buonoValoreListEndpoint, page, perPage, { type:serie })
    .pipe(
      map(({ data, total }) => {
        return {
          data,
          total
        }
      })
    )
  }

  buonoCouponList(page: number, perPage: number, search: string): Observable<{ data: CouponValore[], total: number }> {
    if (this.selectedBuono) {
      return this.baseService.getPaginatedNEW<CouponValore>(this.buonoValoreFidelityEndpoint, page, perPage, { id: this.selectedBuono.cod_buono, NumeroFidelity: search })
        .pipe(
          map(({ data, total }) => {
            return {
              data,
              total
            }
          })
        )
    }
    return of({ data: [], total: 0 });
  }

  couponValoreAdd(codBuono: number, fidelities: CouponValore[]): Observable<any> {
    if (codBuono) {
      const params = {
        codBuono, fidelities
      };
      return this.baseService.postRequestNEW(params, this.buonoValoreFidelityAdd);
    }
    return of(null);
  }

  // VERSIONE OTTIMIZZATA: SqlBulkCopy per grandi quantità (>1000 fidelity da Excel/manuale)
  couponValoreAddBulk(codBuono: number, fidelities: CouponValore[]): Observable<any> {
    if (codBuono) {
      const params = {
        codBuono, fidelities
      };
      return this.baseService.postRequestNEW(params, this.buonoValoreFidelityAddBulk);
    }
    return of(null);
  }

  /**
   * VERSIONE ASINCRONA: Avvia aggiunta di tutte le fidelity connesse in background
   * Ritorna immediatamente con idTask per tracking
   * NOTA: flag_visibile_app viene letto dalla testata del coupon (flag_visibile_app_default)
   */
  addAllFidelitiesConnected(codBuono: number): Observable<any> {
    if (codBuono) {
      const params = { codBuono };
      return this.baseService.postRequestNEW(params, this.buonoValoreFidelityAddAllConnected);
    }
    return of(null);
  }

  /**
   * VERSIONE ASINCRONA: Avvia aggiunta fidelity filtrate per negozi in background
   * Ritorna immediatamente con idTask per tracking
   * NOTA: flag_visibile_app viene letto dalla testata del coupon (flag_visibile_app_default)
   */
  addFidelitiesByShops(codBuono: number, codiciNegozio: string[]): Observable<any> {
    if (codBuono && codiciNegozio && codiciNegozio.length > 0) {
      const params = { codBuono, codiciNegozio };
      return this.baseService.postRequestNEW(params, this.buonoValoreFidelityAddByShops);
    }
    return of(null);
  }

  couponValoreUpdate(fidelity: CouponValore): Observable<any> {
    if (fidelity) {
      return this.baseService.postRequestNEW(fidelity, this.buonoValoreFidelityUpdate);
    }
    return of(null);
  }

  couponValoreDelete(fidelity: CouponValore): Observable<any> {
    if (fidelity) {
      const params = {
        codBuono: fidelity.cod_buono,
        fidelities: [fidelity.numero_fidelity]
      }
      return this.baseService.postRequestNEW(params, this.buonoValoreFidelityDelete)
    }
    return of(null)
  }

  couponValoreAllDelete(codBuono: number): Observable<any> {
    if (codBuono) {
      const params = {
        codBuono
      };
      return this.baseService.postRequestNEW(params, this.buonoValoreFidelityRemoveAll);
    }
    return of(null)
  }

  couponValoreShowAll(codBuono: number): Observable<any> {
    if (codBuono) {
      const params = {
        codBuono
      };
      return this.baseService.postRequestNEW(params, this.buonoValoreFidelityShowAll);
    }
    return of(null)
  }



  couponValoreHideAll(codBuono: number): Observable<any> {
    if (codBuono) {
      const params = {
        codBuono
      };
      return this.baseService.postRequestNEW(params, this.buonoValoreFidelityHideAll);
    }
    return of(null)
  }
  //attivare buoni in app
  cuponValoreActiveAll(codBuono: number): Observable<any> {
    if (codBuono) {
      const params = {
        codBuono
      };
      return this.baseService.postRequestNEW(params, this.buonoValoreActiveAll);
    }
    return of(null)
  }

  cuponValoreDisableAll(codBuono: number): Observable<any> {
    if (codBuono) {
      const params = {
        codBuono
      };
      return this.baseService.postRequestNEW(params, this.buonoValoreDisableAll);
    }
    return of(null)
  }


  buonoCouponRefresh = (amount: number) => {
    if (this.selectedBuono !== undefined && this.selectedBuono !== null) {
      const codBuono = this.selectedBuono.cod_buono;
      const buonoCoupons = this.coupons.filter(x => x.cod_buono == codBuono); //check if cached coupons match with current selection
      const startPage = Math.floor(buonoCoupons.length / amount) + 1;
      return this.baseService.getPaginated<CouponValore[]>(
        this.buonoValoreDetailEndpoint + '/' + codBuono,
        startPage,
        amount,
        (ep, pg, amt) => { return ep + '/' + amt + '/' + pg },
        (data) => {

          const uniqueRowSet = new Set();

          //concat and remove doubles
          const allCoupons = [...this.coupons, ...data].filter((row: CouponValore) => {
            const isPresentInSet = uniqueRowSet.has(row.numero_fidelity);
            uniqueRowSet.add(row.numero_fidelity);
            return !isPresentInSet;
          });
          this.couponList.next(allCoupons);
        });
    }
    else {
      return of(this.coupons);
    }
  }

  buonoValoreUpload(promo: BuonoValore): Observable<any> {
    // Usa postRequestNEW per ritornare Observable senza navigazione automatica
    // Il componente decide quando navigare (solo dopo aver caricato le fidelity)
    return this.baseService.postRequestNEW(promo, this.buonoValoreUploadEndpoint);
  }

  buonoValoreCacheFlush() {
    //after a save, if some elements were changed or removed, I need to empty the cache
    this.couponList.next([]);
  }


  // Regole e effetti

  codeByType(table: TypologyTable, filter: string): Observable<CodeValue[]> {
    return this.baseService.getOnceNEW<CodeValue[]>(this.codeValueData, { table, filter });
  }

  // ==================== Articoli Contingentati B2C ====================

  /**
   * Get list of negozi (PDV) for contingentati dropdown
   */
  getNegoziForContingentati(): Observable<{ codice: string; descrizione: string }[]> {
    return this.baseService.getOnceNEW<{ codice: string; descrizione: string }[]>(
      this.getNegoziForContingentatiEndpoint
    ).pipe(
      catchError(this.handleError(this.getNegoziForContingentatiEndpoint))
    );
  }

  /**
   * Get paginated list of articoli contingentati
   */
  getArticoliContingentati(
    page: number,
    perPage: number,
    searchString?: string
  ): Observable<{ data: ArticoloContingentato[], total: number }> {
    if (page !== 0) {
      return this.baseService.getPaginatedNEW<ArticoloContingentato>(
        this.getArticoliContingentatiEndpoint,
        page,
        perPage,
        { search: searchString || '' }
      ).pipe(
        map(({ data, total }) => ({ data, total })),
        catchError(this.handleError(this.getArticoliContingentatiEndpoint))
      );
    }
    return of({ data: [], total: 0 });
  }

  /**
   * Upload multiple articoli contingentati from Excel
   */
  uploadArticoliContingentati(
    request: ArticoloContingementatoUploadRequest
  ): Observable<ArticoloContingementatoUploadResponse> {
    return this.baseService.postRequestNEW<ArticoloContingementatoUploadResponse>(
      request,
      this.uploadArticoliContingentatiEndpoint
    ).pipe(
      catchError(this.handleError(this.uploadArticoliContingentatiEndpoint))
    );
  }

  /**
   * Update single articolo contingentato
   */
  updateArticoloContingementato(
    articolo: ArticoloContingementatoUpdate
  ): Observable<{ success: boolean; message?: string }> {
    return this.baseService.postRequestNEW<{ success: boolean; message?: string }>(
      articolo,
      this.updateArticoloContingementatoEndpoint
    ).pipe(
      catchError(this.handleError(this.updateArticoloContingementatoEndpoint))
    );
  }
}

export type TypologyTable = 'brands' | 'stati' | 'produttori' | 'fornitori' | 'articoli' | 'meloni' | 'brand_famiglia';

export interface CodeType {
  code: TipoCodice,
  name: string,
  type?: TypologyTable
}

export const ELENCO_TIPO: CodeType[] = [
  { code: TipoCodice.ListaArticoli, name: "Lista Articoli", type: 'articoli' },
  { code: TipoCodice.FamigliaMeloni, name: "Famiglia Meloni", type: 'meloni' },
  { code: TipoCodice.Stato, name: "Stato", type: 'stati' },
  { code: TipoCodice.TotaleSpesa, name: "Totale Spesa" },
  { code: TipoCodice.Fornitore, name: "Fornitore", type: 'fornitori' },
  { code: TipoCodice.Brand, name: "Brand", type: 'brands' },
  { code: TipoCodice.Produttore, name: "Produttore", type: 'produttori' },
  { code: TipoCodice.brandFamiglia, name: "Brand Famiglia", type: 'brand_famiglia' }
];
